import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { JobsPanelComponent } from './lib/jobs-panel.component'
import { JobsKey } from './panel-key'

export const JobsPanelConfig: PanelConfig = {
  key: JobsKey,
  title: 'Jobs',
  description:
    'View details for reconciliation runs including run times and submitted commands.',
  category: PanelCategory.DELIVERY,
  panelComponent: JobsPanelComponent,
  accessPermission: 'accessJobsPanel',
}
